// extracted by mini-css-extract-plugin
export default {"container":"QuickLaunch_container__EPf-e"};